var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{attrs:{"color":"success","dark":"","icon":"mdi-check-circle-outline","border":"right","dense":""}},[_c('b',[_vm._v(_vm._s(_vm.title)+" ")]),_vm._v(" "+_vm._s(_vm.message)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }